import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

// shadcn-vue's standard `cn` helper (components.json -> aliases.utils).
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
